import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TABS } from '@src/constants/notification';
import { StyledTabs } from './index.style';

const NotificationTabs = ({ activeGroup, unreadStatus = {}, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <StyledTabs>
      {NOTIFICATION_TABS.map((tab) => (
        <Box
          key={tab.key}
          className={`tab-item ${activeGroup === tab.key ? 'active' : ''}`}
          onClick={(e) => {
            e.stopPropagation();
            onTabChange(tab.key);
          }}
        >
          {t(tab.labelKey)}
          {unreadStatus[tab.key] && <Box className="unread-dot" />}
        </Box>
      ))}
    </StyledTabs>
  );
};

export default NotificationTabs;
